<!-- 页面参考 sms/index -->
<template>
  <div class="sms" ref="smsDOM">
    <!-- 头部查询内容 -->
    <div class="header">
      <!-- 第一行 -->
      <div class="header-line">
        <div class="header-item">
          <label class="label" for="">发送类型：</label>
          <a-select
            allowClear
            class="select"
            placeholder="请选择发送类型"
            v-model:value="query.sendType"
            :options="outLine"
          ></a-select>
        </div>
        <div class="header-item">
          <label class="label" for="">发送状态：</label>
          <a-select
            class="select"
            allowClear
            placeholder="全部发送状态"
            v-model:value="query.sendStatus"
            :options="sendOptions"
          ></a-select>
        </div>
        <div v-if="false" class="header-item">
          <label class="label" for="">全部触达状态：</label>
          <!-- NOTE:这个展示不现实 -->
          <a-select
            class="select"
            allowClear
            placeholder="全部触达状态"
            v-model:value="query.readStatus"
            :options="readOptions"
          ></a-select>
        </div>
      </div>
      <!-- 第二行 -->
      <div class="header-line">
        <div class="left">
          <div class="header-item">
            <label class="label" for="">角色：</label>
            <a-select
              allowClear
              class="select"
              placeholder="请选择"
              v-model:value="query.operatedPerson"
              :options="OPERATED_PERSON"
              @change="changeOperatedPerson"
            ></a-select>
            <a-select
              allowClear
              @change="changePersonRole"
              class="select"
              placeholder="全部角色"
              v-model:value="query.userRole"
              :options="roles"
            ></a-select>
            <a-input
              placeholder="请输入姓名"
              allowClear
              @keyup.enter="onPageOrSize({ current: 1 })"
              class="select"
              @input="e => changeName(e.target.value)"
              v-model:value="query.userName"
            ></a-input>
          </div>
          <div class="header-item">
            <label class="label" for="">发送时间：</label>
            <a-range-picker :valueFormat="dateFormat" v-model:value="query.date" />
          </div>
        </div>
        <div class="search-line">
          <a-button
            class="search-button"
            @click="
              () => {
                resetQuery()
                onPageOrSize({ current: 1, pageSize: 10 })
              }
            "
          >
            重置
          </a-button>
          <a-button class="search-button" type="primary" @click="onPageOrSize({ current: 1 })">
            搜索
          </a-button>
        </div>
      </div>
    </div>
    <div class="body-table">
      <a-table
        ref=""
        class="my-table"
        @showSizeChange="onPageOrSize"
        :rowKey="record => record.id"
        @change="onPageOrSize"
        :pagination="query.pagination"
        :transformCellText="({ text }) => text || '--'"
        :columns="columns"
        :data-source="tableData"
        :scroll="{ x: 100, y: 'calc(100vh - 300px)' }"
      >
        <template #sendPerson="{ record }">
          <RoleTag :role="record.sendPersonRole">
            {{ record.sendPerson }}
          </RoleTag>
        </template>
        <template #receivePerson="{ record }">
          <RoleTag :role="record.receivePersonRole">
            {{ record.receivePerson }}
          </RoleTag>
        </template>
        <template #sendStatus="{ record }">
          <a-tag v-if="record.sendStatus" color="success">发送成功</a-tag>
          <a-tag v-else color="error">发送失败</a-tag>
        </template>
        <template #smsInfo="{ text }">
          <a-tooltip
            :getPopupContainer="() => smsDOM"
            overlayClassName="my-tooltip"
            placement="bottom"
            class="two-line"
          >
            <template #title>{{ text }}</template>
            <div class="tooltip-body">
              {{ text }}
            </div>
          </a-tooltip>
        </template>
        <template #mainRelatedWorkOrder="{ text }">
          <a-button v-if="text" size="small" type="link" @click="onOperation(text)">
            {{ text }}
          </a-button>
          <span v-else>--</span>
        </template>
      </a-table>
    </div>
    <PatientInfoDetails
      @handleCancel="handleCancel"
      :showAllDialog="dialog.show"
      :currentInfo="dialog.info"
    />
  </div>
</template>
<script setup>
import { smsTemplateContent } from '@/api/workPlace/SMS'
import PatientInfoDetails from '@/components/PatientInfoDetails'
import { onMounted, reactive, ref, computed } from 'vue'
import { readOptions, sendOptions, roleOptions } from '../WorkPlace/Container/SMS//config'

import moment from 'moment'
import { getSMSInfo } from '@/api/workPlace/SMS'
import { getWorkOrderListAsyn as getWorkOrderListAsync, getWorkOrderListByTaskId } from '@/api/Todo'
import { message } from 'ant-design-vue'
import RoleTag from '../WorkPlace/Container/SMS/RoleTag.vue'
import { columns, OPERATED_PERSON } from './config'
import { useFilterCache } from '@/hooks/useFilterCache'
import { FILTER_CACHE_PAGE_KEYS } from '@/constants/filterCache'
import { useStore } from 'vuex'
import { cloneDeep } from 'lodash-es'
const dateFormat = 'YYYY-MM-DD'
const smsDOM = ref()
const getDefaultDateRange = () => {
  const end = moment().format(dateFormat)
  const start = moment(end).subtract(1, 'months').format(dateFormat)
  return [start, end]
}
// 下啦内容
const outLine = ref([])
const tableData = ref([])
const roles = ref()
const defaultQueryData = {
  date: getDefaultDateRange(),
  userRole: null,
  operatedPerson: 'all',
  userName: '',
  readStatus: null,
  receivePersonRole: null,
  sendPersonRole: null,
  sendStatus: null,
  workOrderId: null,
  sendPersonName: '',
  receivePersonName: '',
  sendType: null
}
const defaultPagination = {
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 100,
  size: 'small',
  showTotal: total => `共 ${total} 条`
}
const query = ref({
  ...defaultQueryData,
  pagination: { ...defaultPagination }
})
const store = useStore()
const { initFromCache, updateCache } = useFilterCache({
  pageKey: FILTER_CACHE_PAGE_KEYS.SMS_LOG_LIST,
  userId: computed(() => store.state.user.userId),
  defaultParams: defaultQueryData,
  normalize: params => ({
    ...cloneDeep(defaultQueryData),
    ...cloneDeep(params),
    date: Array.isArray(params?.date) ? params.date : []
  })
})
const dialog = reactive({
  show: false,
  info: {}
})
async function onOperation(data) {
  // 最多执行10次
  let loopCount = 0
  const loopFetch = () => {
    // 第十次跳出（实际第11次 0 开始）
    if (loopCount === 10) return
    setTimeout(async () => {
      const resultWork = await getWorkOrderListByTaskId({ taskId })
      const list = resultWork.list
      if (list && list.length > 0) {
        workOrder = list[0]
        dialog.show = true
        dialog.info = workOrder
      } else if (list?.length === 0) {
        const errMsg = `工单ID${data}不存在或暂无查看权限`
        message.error(errMsg)
      } else {
        loopFetch()
        loopCount++
      }
    }, 100)
  }
  const params = {
    workOrderIdList: [data],
    curPage: 1,
    pageSize: 10,
    allocateTimeStart: '',
    allocateTimeEnd: '',
    completeTimeStart: '',
    completeTimeEnd: '',
    dealTimeStart: '',
    dealTimeEnd: '',
    createTimeStart: '',
    createTimeEnd: '',
    unAllocatedFlag: null
  }
  // 循环后去数据
  let workOrder
  const result = await getWorkOrderListAsync(params)
  const { taskId, list } = result
  // 如果有数据直接渲染，没有数据拿 taskID 去轮训
  if (list && list.length) {
    workOrder = list[0]
    dialog.show = true
    dialog.info = workOrder
  } else if (taskId) {
    loopFetch()
  } else {
    const errMsg = `工单ID${data}不存在或暂无查看权限`
    message.error(errMsg)
  }
}
// 获取数据
function getData() {
  const [start, end] = query.value.date
  const params = {
    sendPersonName: query.value.sendPersonName,
    receivePersonName: query.value.receivePersonName,
    sendType: query.value.sendType,
    readStatus: query.value.readStatus,
    receivePersonRole: query.value.receivePersonRole,
    sendPersonRole: query.value.sendPersonRole,
    sendStatus: query.value.sendStatus,
    sendStartTime: start,
    sendEndTime: end,
    pageNo: query.value.pagination.current,
    pageSize: query.value.pagination.pageSize,
    workOrderId: null,
    doctorUcId: null,
    patientUcId: null
  }
  tableData.value = []
  getSMSInfo(params).then(result => {
    const { list, totalCount } = result
    query.value.pagination.total = totalCount
    tableData.value = list
  })
}
// 改变当前页 和 改变页码值
function onPageOrSize({ current, pageSize }) {
  query.value.pagination.pageSize = pageSize || query.value.pagination.pageSize
  query.value.pagination.current = current
  updateCache({ ...query.value, pagination: undefined })
  getData()
}
function handleCancel() {
  dialog.show = false
}
// 改变接收人
function changeOperatedPerson(e) {
  const roleMAP = {
    all: [null, 1, 2, 3, 4],
    undefined: [null, 1, 2, 3, 4],
    receive: [1, 2, 3],
    send: [3, 4]
  }
  roles.value = roleOptions.filter(f => roleMAP[e].includes(f.value))
  changePersonRole(query.value.userRole)
}
// 改变角色
function changePersonRole(e) {
  query.value.receivePersonRole = query.value.operatedPerson !== 'send' ? e : null
  query.value.sendPersonRole = query.value.operatedPerson !== 'receive' ? e : null
  changeName(query.value.userName)
}
// 改名称
function changeName(e) {
  query.value.receivePersonName = query.value.operatedPerson !== 'send' ? e : null
  query.value.sendPersonName = query.value.operatedPerson !== 'receive' ? e : null
}
function resetQuery() {
  roles.value = roleOptions.filter(f => [null, 1, 2, 3, 4].includes(f.value))
  query.value = {
    ...defaultQueryData,
    pagination: {
      ...defaultPagination
    }
  }
  updateCache({ ...query.value, pagination: undefined })
}
// 获取发送类型
const getOutline = () =>
  new Promise(resolve => {
    const params = {
      parentId: 0,
      type: null,
      templateParas: { doctorUcId: null, hospitalId: null }
    }
    smsTemplateContent(params).then(result => {
      console.log(result)
      let options = new Set(result.map(m => m.name))
      options = ['全部类型', ...options]
      resolve(options)
    })
  })
onMounted(() => {
  const cacheQuery = initFromCache()
  query.value = {
    ...defaultQueryData,
    ...cacheQuery,
    pagination: {
      ...defaultPagination
    }
  }
  roles.value = roleOptions.filter(f => [null, 1, 2, 3, 4].includes(f.value))
  changePersonRole(query.value.userRole)
  getOutline().then(result => {
    outLine.value = result.map(m => {
      return { label: m, value: m === '全部类型' ? null : m }
    })
    onPageOrSize({ current: 1, pageSize: 10 })
  })
})
</script>
<style lang="scss" scoped>
.sms {
  height: 100%;
  .header {
    padding: 10px 20px 10px;
    background-color: white;
    .header-line {
      display: flex;
      &:first-child {
        margin-bottom: 12px;
      }
      .left {
        display: flex;
      }
      .header-item {
        .label {
          margin-right: 4px;
        }
        .select {
          width: 220px;
          margin-right: 12px;
        }
        &:last-child {
          margin-right: 12px;
        }
      }
      .search-line {
        text-align: right;
        display: inline-block;
        .search-button:first-child {
          margin-right: 8px;
        }
      }
    }
  }
  .body-table {
    background-color: white;
    padding: 12px 12px 0;
    margin: 12px;
    ::v-deep(.my-table) {
      // display: block;
      .two-line {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
    }
  }
  // 黑色弹出的提示内容框 样式
  ::v-deep(.my-tooltip) {
    .ant-tooltip-content {
      .ant-tooltip-inner {
        border-radius: 4px;
      }
    }
  }
}
</style>
